export const ACCOUNTING_PRICING_PACKAGES = [
  {
    code: "accounting_independent_sole",
    label: "Independent professional, sole proprietor",
    shortLabel: "Independent sole proprietor",
    audience: "Solo beauty professional",
    priceCents: 3900,
    priceLabel: "$39",
    range: "No staff payroll",
  },
  {
    code: "accounting_independent_corp",
    label: "Independent professional, incorporated",
    shortLabel: "Independent incorporated",
    audience: "Incorporated solo beauty business",
    priceCents: 19900,
    priceLabel: "$199",
    range: "No staff payroll",
  },
  {
    code: "accounting_salon_sole_0_3",
    label: "Salon owner, sole proprietor, 0-3 payroll staff",
    shortLabel: "Salon sole proprietor",
    audience: "Small salon team",
    priceCents: 8900,
    priceLabel: "$89",
    range: "0 to 3 payroll staff",
  },
  {
    code: "accounting_salon_sole_4_6",
    label: "Salon owner, sole proprietor, 4-6 payroll staff",
    shortLabel: "Salon sole proprietor",
    audience: "Growing salon team",
    priceCents: 12900,
    priceLabel: "$129",
    range: "4 to 6 payroll staff",
  },
  {
    code: "accounting_salon_sole_7_10",
    label: "Salon owner, sole proprietor, 7-10 payroll staff",
    shortLabel: "Salon sole proprietor",
    audience: "Busy salon team",
    priceCents: 17900,
    priceLabel: "$179",
    range: "7 to 10 payroll staff",
  },
  {
    code: "accounting_salon_corp_0_3",
    label: "Salon owner, incorporated, 0-3 payroll staff",
    shortLabel: "Salon incorporated",
    audience: "Small incorporated salon",
    priceCents: 19900,
    priceLabel: "$199",
    range: "0 to 3 payroll staff",
  },
  {
    code: "accounting_salon_corp_4_6",
    label: "Salon owner, incorporated, 4-6 payroll staff",
    shortLabel: "Salon incorporated",
    audience: "Growing incorporated salon",
    priceCents: 25900,
    priceLabel: "$259",
    range: "4 to 6 payroll staff",
  },
  {
    code: "accounting_salon_corp_7_10",
    label: "Salon owner, incorporated, 7-10 payroll staff",
    shortLabel: "Salon incorporated",
    audience: "Busy incorporated salon",
    priceCents: 31900,
    priceLabel: "$319",
    range: "7 to 10 payroll staff",
  },
];

export const ACCOUNTING_PRICING_SUMMARY = [
  "Staff access is included with the salon owner package.",
  "Independent professionals start at $39/month.",
  "Incorporated support starts at $199/month.",
  "Salon owner pricing scales with payroll staff count.",
  "11+ payroll staff is custom quote.",
];
